import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

import SyncForm from './SyncForm';

const styles = () => ({
  root: {
    padding: '1rem',
    backgroundColor: '#ffffff',
  },
  header: {
    marginBottom: '1rem',
  },
  tabsRoot: {
    borderBottom: '1px solid #e0e0e0',
  },
  tabIndicator: {
    backgroundColor: '#3f51b5',
  },
  tab: {
    textTransform: 'none',
    fontWeight: 600,
    minWidth: 120,
  },
});

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>
    {value === index && <Box>{children}</Box>}
  </div>
);

const DataSync = ({ classes }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={classes.root}>
      <Typography variant='h6' className={classes.header}>
        Data Sync
      </Typography>
      <Paper elevation={0}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          classes={{
            root: classes.tabsRoot,
            indicator: classes.tabIndicator,
          }}
        >
          <Tab label='Sync PO' className={classes.tab} />
          <Tab label='Update PO' className={classes.tab} />
          <Tab label='Sync Inventory' className={classes.tab} />
        </Tabs>
        <TabPanel value={activeTab} index={0}>
          <SyncForm type='syncPO' />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <SyncForm type='updatePO' />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <SyncForm type='syncInventory' />
        </TabPanel>
      </Paper>
    </div>
  );
};

export default withStyles(styles)(withRouter(DataSync));
